const base = (site) => (site?.seo?.site_url || window.location.origin).replace(/\/$/, "");

export const orgLd = (site) => {
  if (!site) return null;
  const p = site.parent || {};
  const socials = (site.footer?.socials || []).map((s) => s.url).filter(Boolean);
  return {
    "@context": "https://schema.org", "@type": ["Organization", "ProfessionalService"], "@id": `${base(site)}/#organization`,
    name: "EditBay", alternateName: "EditBay by Relatable Studio", url: base(site), logo: `${base(site)}/brand/logo-512.png`,
    image: `${base(site)}/brand/og-image.png`, description: site.brand?.description, email: site.footer?.contact_email || undefined,
    areaServed: { "@type": "Country", name: "India" }, priceRange: "₹4,700+ (excl. 18% GST)", currenciesAccepted: "INR",
    knowsAbout: ["Video editing", "Instagram Reels editing", "YouTube Shorts editing", "Podcast video editing", "Talking-head video editing", "Motion graphics", "Branded video editing"],
    ...(socials.length ? { sameAs: socials } : {}),
    ...(p.name ? { parentOrganization: { "@type": "Organization", name: p.name, ...(p.url ? { url: p.url } : {}) } } : {}),
  };
};

export const websiteLd = (site) => site && {
  "@context": "https://schema.org", "@type": "WebSite", name: "EditBay by Relatable Studio", url: base(site),
  publisher: { "@id": `${base(site)}/#organization` },
};

export const breadcrumbLd = (site, crumbs) => site && {
  "@context": "https://schema.org", "@type": "BreadcrumbList",
  itemListElement: crumbs.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${base(site)}${path}` })),
};

export const serviceLd = (site, page, path) => site && {
  "@context": "https://schema.org", "@type": "Service", name: page.title, description: page.summary, serviceType: page.nav_label || page.title,
  url: `${base(site)}${path}`, provider: { "@id": `${base(site)}/#organization` }, areaServed: "IN",
};

export const videoLd = (site, item, path) => {
  if (!site || !item?.video_url || !item?.thumbnail_url) return null;
  return {
    "@context": "https://schema.org", "@type": "VideoObject", name: item.title, description: item.description || item.title,
    thumbnailUrl: item.thumbnail_url, contentUrl: item.video_url, uploadDate: item.created_at, url: `${base(site)}${path}`,
  };
};
